import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Store } from '@df/catalog/store/store';
import { StoreService } from '@df/catalog/store/store.service';

export const storesResolver: ResolveFn<Store[]> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const storeService = inject(StoreService);

    await storeService.loadAll(undefined, 1);

    return storeService.resource.getAllExisting();
};
